import { useEffect, useState } from "react";
import styles from "./UnitCardBasicInfo.module.scss";
import { Collapse, Tab, Tabs } from "@mui/material";

import { FacultyCard, LoadingListEntityProfile } from "Explore/Components";
import PublicationItem from "Explore/Components/PublicationItem";
import { Empty } from "antd";
import AwardItem from "Explore/Components/AwardItem";
import D3Graph from "Explore/Components/Graph";
import {
  getUnitAwardedGrantsById,
  getUnitCollaboratorsGraphById,
  getUnitFacultyById,
  getUnitPublicationsById,
} from "Explore/Services/Unit";
import { IconPack } from "Explore/Config/Icons";

const MAP_TAB_VALUES = Object.freeze({
  SCHOLARS: 1,
  PUBLICATIONS: 2,
  GRANTS: 3,
  COLLABORATORS: 4,
});

const TAB_VALUES = [
  {
    label: "Scholars",
    value: MAP_TAB_VALUES.SCHOLARS,
    icon: IconPack.unit_faculty_members,
  },
  {
    label: "Notable Scholarly Works",
    value: MAP_TAB_VALUES.PUBLICATIONS,
    icon: IconPack.unit_publications,
  },
  {
    label: "Notable Federal Grants",
    value: MAP_TAB_VALUES.GRANTS,
    icon: IconPack.grant,
  },
  {
    label: "Collaborators",
    value: MAP_TAB_VALUES.COLLABORATORS,
    icon: IconPack.collaborator,
  },
];

const UnitCardBasicInfo = ({ id }) => {
  const [tabValue, setTabValue] = useState(false);
  const [scholars, setScholars] = useState({ data: [], isLoading: true });
  const [publications, setPublications] = useState({
    data: [],
    isLoading: true,
  });
  const [grants, setGrants] = useState({ data: [], isLoading: true });
  const [collaborators, setCollaborators] = useState({
    data: [],
    isLoading: true,
  });

  useEffect(() => {
    if (tabValue === MAP_TAB_VALUES.SCHOLARS && scholars.isLoading) {
      getUnitFacultyById({ id, rowsPerPage: 3 }).then((res) => {
        setScholars({ data: res.results, isLoading: false });
      });
    }
  }, [tabValue, scholars.isLoading]);
  useEffect(() => {
    if (tabValue === MAP_TAB_VALUES.PUBLICATIONS && publications.isLoading) {
      getUnitPublicationsById({ id, rowsPerPage: 3 }).then((res) => {
        setPublications({ data: res.results, isLoading: false });
      });
    }
  }, [tabValue, publications.isLoading]);
  useEffect(() => {
    if (tabValue === MAP_TAB_VALUES.GRANTS && grants.isLoading) {
      getUnitAwardedGrantsById({ id, rowsPerPage: 3 }).then((res) => {
        setGrants({ data: res.results, isLoading: false });
      });
    }
  }, [tabValue, grants.isLoading]);
  useEffect(() => {
    if (tabValue === MAP_TAB_VALUES.COLLABORATORS && collaborators.isLoading) {
      getUnitCollaboratorsGraphById({ id, top_k: 10 }).then((res) =>
        setCollaborators({ data: res.data, isLoading: false })
      );
    }
  }, [tabValue, collaborators.isLoading]);

  const handleChange = (_, newValue) => {
    setTabValue(newValue);
  };

  return (
    <div className={styles["basic-info"]}>
      <Tabs
        value={tabValue}
        onChange={handleChange}
        classes={{
          root: styles["tabs"],
          indicator: styles["tabs--indicator"],
        }}
        variant="scrollable"
        allowScrollButtonsMobile
      >
        {TAB_VALUES.map(({ label, value, icon }) => (
          <Tab
            key={value}
            label={label}
            value={value}
            icon={icon}
            iconPosition="start"
            onClick={() => value === tabValue && setTabValue(false)}
            classes={{
              root: styles["tabs--item"],
              selected: styles["selected"],
            }}
          />
        ))}
      </Tabs>

      <Collapse
        in={tabValue != false}
        classes={{ wrapperInner: styles["tabs--content"] }}
      >
        {tabValue === MAP_TAB_VALUES.SCHOLARS && (
          <div className={styles["scholars-list"]}>
            <LoadingListEntityProfile
              isLoading={scholars.isLoading}
              component={
                scholars.data?.length > 0 ? (
                  scholars.data.map((item, index) => {
                    return <FacultyCard simpleMode key={index} data={item} />;
                  })
                ) : (
                  <Empty description="No Scholar Found." />
                )
              }
              componentNum={3}
              avatar={true}
            />
          </div>
        )}
        {tabValue === MAP_TAB_VALUES.PUBLICATIONS && (
          <LoadingListEntityProfile
            isLoading={publications.isLoading}
            component={
              publications.data?.length > 0 ? (
                publications.data.map((item, index) => {
                  return <PublicationItem key={index} data={item} />;
                })
              ) : (
                <Empty description="No Publication Found." />
              )
            }
            componentNum={3}
            avatar={true}
          />
        )}
        {tabValue === MAP_TAB_VALUES.GRANTS && (
          <LoadingListEntityProfile
            isLoading={grants.isLoading}
            component={
              grants.data?.length > 0 ? (
                grants.data.map((item, index) => {
                  return <AwardItem key={index} data={item} />;
                })
              ) : (
                <Empty description="No Award Found." />
              )
            }
            componentNum={3}
            avatar={true}
          />
        )}
        {tabValue === MAP_TAB_VALUES.COLLABORATORS && (
          <D3Graph
            simpleMode
            data={collaborators.data}
            isLoading={collaborators.isLoading}
            height={300}
            graphType="unit"
          />
        )}
      </Collapse>
    </div>
  );
};

export default UnitCardBasicInfo;
